import React from 'react';

function Footer() {
  return (
    <div
      className="app-footer"
      style={{
        height: '80px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 'var(--text-xs)',
      }}
    >
      <p>Copyright © 2026 Re-Current Co., Ltd. All rights reserved.</p>
    </div>
  );
}

export default Footer;
